import React from 'react';
import { Card } from './Card';
import { SectionHeader } from './SectionHeader';
interface SettingsSectionProps {
  /** Section title */
  title: string;
  /** Section description */
  description?: string;
  /** Lucide icon component */
  icon: React.ElementType;
  /** Accent color classes: 'bg-{color}-100 text-{color}-600' */
  accentColor?: string;
  /** Optional right-side action (e.g. a button) */
  action?: React.ReactNode;
  /** Card content */
  children: React.ReactNode;
  /** Extra classes on the Card wrapper */
  className?: string;
}
export function SettingsSection({
  title,
  description,
  icon: Icon,
  accentColor = 'bg-indigo-100 text-indigo-600',
  action,
  children,
  className = ''
}: SettingsSectionProps) {
  return <Card className={`p-6 ${className}`} data-id="element-2675">
      <SectionHeader title={title} description={description} icon={Icon} accentColor={accentColor} action={action} size="sm" className="mb-6" data-id="element-2676" />
      {children}
    </Card>;
}